<template>
  <div :class="{ 'p-6': $mq != 'mobile', 'p-4 w-screen': $mq == 'mobile' }">
    <mq-layout mq="mobile">
      <div class="p-6">
        <label>Show:</label>
        <button
          type="button"
          class="p-3 py-2 rounded"
          :class="{
            'bg-brand text-white': interval == 'monthly',
            'border border-brand text-brand': interval != 'monthly',
          }"
          @click.prevent="interval = 'monthly'"
        >
          Monthly
        </button>
        <button
          type="button"
          class="p-3 py-2 rounded"
          :class="{
            'bg-brand text-white': interval == 'yearly',
            'border border-brand text-brand': interval != 'yearly',
          }"
          @click.prevent="interval = 'yearly'"
        >
          Yearly
        </button>
      </div>
      <div
        class="
          w-1/2
          bg-brand
          mx-auto
          text-white text-center
          rounded-full
          p-1
          my-4
        "
      >
        Swipe left for more
      </div>
    </mq-layout>

    <mq-layout mq="tablet+">
      <div class="p-6">
        <label>Show:</label>
        <button
          type="button"
          class="p-3 py-2 rounded"
          :class="{
            'bg-brand text-white': interval == 'monthly',
            'border border-brand text-brand': interval != 'monthly',
          }"
          @click.prevent="interval = 'monthly'"
        >
          Monthly
        </button>
        <button
          type="button"
          class="p-3 py-2 rounded"
          :class="{
            'bg-brand text-white': interval == 'yearly',
            'border border-brand text-brand': interval != 'yearly',
          }"
          @click.prevent="interval = 'yearly'"
        >
          Yearly
        </button>
      </div>
      <div class="flex items-stretch">
        <div
          v-for="(subscription, subscription_type) in subscriptions"
          :key="subscription_type"
          class="border mx-3 flex-1 hover:shadow-lg"
          :class="{
            'shadow-lg border-brand': form.plan == subscription_type,
          }"
        >
          <!-- Header -->
          <div
            class="
              py-4
              text-center
              bg-brand-lightest
              uppercase
              text-lg
              tracking-wider
              text-grey-darker
            "
          >
            {{ subscription[interval].name }}
          </div>
          <!-- Price -->
          <div
            class="py-4 px-2 text-center bg-modal-gradient border-t flex flex-col"
          >
            <div class="w-full flex text-white justify-center items-center">
              <span class="font-light text-2xl text-right currency -mt-3 whitespace-no-wrap"
                >{{ form.vault.country && form.vault.country.code == 'NZ' ? 'NZ' : '' }}$</span
              >
              <span class="font-light text-5xl amount">{{
                parseFloat(subscription[interval].price).toFixed(2)
              }}</span>
              <span
                class="
                  font-light
                  text-2xl text-left
                  per-month
                  self-end
                  mb-2
                  ml-1
                "
                >{{ interval == 'yearly' ? '/yr' : '/mo' }}</span
              >
            </div>
            <p
              class="text-white uppercase text-xs"
              v-if="
                subscription[interval].description &&
                subscription[interval].description.pricing_description
              "
            >
              {{ subscription[interval].description.pricing_description }}
            </p>
          </div>
          <!-- Subtext -->
          <div
            class="
              px-8
              py-4
              pb-6
              h-20
              text-center
              bg-grey-lightest
              text-sm text-grey-darker text-center
              flex
              justify-center
              items-center
            "
            v-if="
              subscription[interval].description &&
              subscription[interval].description.subtext
            "
            v-html="subscription[interval].description.subtext"
          ></div>
          <div
            class="
              px-8
              py-4
              text-center
              uppercase
              bg-grey-lightest
              text-xs text-grey-darker text-center
            "
            v-if="
              subscription[interval].description &&
              subscription[interval].description.pricing_options
            "
          >
            <p
              class="p-1"
              v-for="option in subscription[interval].description
                .pricing_options"
            >
              {{ option }}
            </p>
            <p class="p-1 text-orange">
              {{ subscription[interval].description.savings }}
            </p>
          </div>
          <!-- List -->
          <div
            class="
              py-4
              px-8
              bg-white
              text-sm text-grey-darker text-center
              flex flex-col
              h-64
              justify-between
            "
          >
            <div class="flex-none justify-center items-center">
              <ul
                class="text-left"
                v-if="
                  subscription[interval].description &&
                  subscription[interval].description.features
                "
              >
                <li
                  v-for="(feature, idx) in subscription[interval].description
                    .features"
                  class="p-1"
                >
                  <i class="fa fa-check text-brand"></i>
                  <span :class="{ 'font-medium': idx == 0 }">{{
                    feature
                  }}</span>
                </li>
              </ul>
            </div>
            <div class="flex-none">
              <button
                class="
                  px-6
                  py-3
                  text-white
                  rounded
                  text-lg
                  mt-6
                  hover:bg-brand-dark
                  font-medium
                "
                :class="{
                  'bg-brand-darker': form.plan == subscription_type,
                  'bg-brand': form.plan != subscription_type,
                }"
                @click="select(subscription_type)"
              >
                <span v-if="form.plan == subscription_type">
                  <i class="fa fa-check fa-2xl"></i> Selected
                </span>

                <span v-else>Select</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </mq-layout>

    <mq-layout
      mq="mobile"
      class="w-full flex-none overflow-x-auto overflow-hidden"
    >
      <div class="w-full flex">
        <div
          v-for="(subscription, subscription_type) in subscriptions"
          :key="subscription.id"
          class="border mx-4 w-3/4 flex-none"
          :class="{ 'shadow-lg border-brand': form.plan == subscription_type }"
        >
          <!-- Header -->
          <div
            class="
              py-4
              text-center
              bg-brand-lightest
              uppercase
              text-lg
              tracking-wider
              text-grey-darker
            "
          >
            {{ subscription[interval].name }}
          </div>
          <!-- Price -->
          <div
            class="py-4 text-center bg-modal-gradient border-t flex flex-col"
          >
            <div class="text-white relative">
              <span
                class="
                  font-light
                  text-xl text-right
                  currency
                  absolute
                  -mt-3
                "
                style="margin-left: -2.5rem;"
                >{{ form.vault.country && form.vault.country.code == 'NZ' ? 'NZ' : '' }}$</span
              >
              <span class="font-light text-4xl amount">{{
                subscription[interval].price
              }}</span>
              <span
                class="
                  font-light
                  text-xl text-left
                  per-month
                  self-end
                  mb-2
                  ml-1
                "
                >/mo</span
              >
            </div>
          </div>

          <!-- Subtext -->
          <div
            class="
              py-4
              text-center
              bg-grey-lightest
              text-sm text-grey-darker text-center
            "
            v-if="
              subscription[interval].description &&
              subscription[interval].description.subtext
            "
          >
            <p>{{ subscription[interval].description.subtext }}</p>
          </div>
          <div
            class="
              py-4
              text-center
              uppercase
              bg-grey-lightest
              text-xs text-grey-darker text-center
            "
            v-if="
              subscription[interval].description &&
              subscription[interval].description.pricing_options
            "
          >
            <p
              class="p-1"
              v-for="option in subscription[interval].description
                .pricing_options"
            >
              {{ option }}
            </p>
            <p class="p-1 text-orange">
              {{ subscription[interval].description.savings }}
            </p>
          </div>

          <div
            class="
              py-4
              bg-white
              text-center text-xs
              uppercase
              text-grey-darker
              font-medium
              break-words
              flex flex-col
              justify-between
            "
          >
            <div
              class="flex justify-center items-center"
              v-if="subscription[interval].description.features.length != 0"
            >
              <ul class="text-left">
                <li
                  v-for="(feature, idx) in subscription[interval].description
                    .features"
                >
                  <i class="fa fa-check text-brand"></i>
                  <span :class="{ 'font-medium': idx == 0 }">{{
                    feature
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="py-2 text-center">
            <button
              class="p-2 text-white rounded text-lg font-medium"
              :class="{
                'bg-brand-darker': form.plan == subscription_type,
                'bg-brand': form.plan != subscription_type,
              }"
              @click="select(subscription_type)"
            >
              <span v-if="form.plan == subscription_type">
                <i class="fa fa-check fa-2xl"></i> Selected
              </span>

              <span v-else>Select</span>
            </button>
          </div>
        </div>
      </div>
    </mq-layout>

    <div class="text-center sm:text-left mt-8 sm:ml-6">
      <button
        class="
          bg-grey-lighter
          px-8
          py-3
          w-32
          text-black
          rounded
          text-lg
          border border-grey
          text-center
          font-medium
          hover:bg-grey hover:text-white
        "
        @click.prevent="back()"
      >
        Back
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "subscriptions", "step"],

  data() {
    return {
      interval: "monthly",
      form: _.cloneDeep(this.value),

      next: "",
      prev: "",
    };
  },

  mounted() {
    let next = _.toNumber(this.step) + 1;
    this.next = next;

    let prev = _.toNumber(this.step) - 1;
    this.prev = prev;
  },

  methods: {
    select(subscription_type) {
      this.form.plan = subscription_type;
      // this.form.plan_cycle = (this.form.plan_cycle != '') ? this.form.plan_cycle : 'monthly';
      // if (this.form.billing.type == '') {
      //     this.form.billing.type = 'direct-debit';
      // }
      this.validateAndNext();
    },
    validateAndNext() {
      this.$emit("input", this.form);
      this.$emit("go-to", {
        next_step: this.next,
      });
    },
    back() {
      this.$emit("go-to", {
        next_step: this.prev,
        next_sub_step: 2,
      });
    },
  },

  watch: {
    form: {
      deep: true,
      handler: function () {
        this.$emit("input", this.form);
      },
    },
    interval: {
      handler: function () {
        this.form.plan_cycle = this.interval;
      },
    },
  },

  computed: {
    vault_type() {
      return window.vault_type;
    },
  },
};
</script>

<style>
.per-month {
  line-height: 38px;
}
.amount {
  line-height: 78px;
}
.currency {
  line-height: 78px;
}
.bg-gradient {
  background: linear-gradient(270deg, #6078fd 0%, #04daff 100%);
}
</style>

